import { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './mochi-refueling-tutorial-vertical-list.module.sass';
import Lottie from 'react-lottie';
import { REFUELING_TUTORIAL_VERTICAL_LIST_DATA } from '../../const';

const cx = classNames.bind(styles);

const ITEM_CLASS_NAME = 'mochi-tutorial-vertical-list-item';

interface MochiRefuelingTutorialVerticalListProps {
  refuelingService: 'autopass' | 'barcode' | 'mochipay';
}

export const MochiRefuelingTutorialVerticalList = ({
  refuelingService,
}: MochiRefuelingTutorialVerticalListProps) => {
  const list = REFUELING_TUTORIAL_VERTICAL_LIST_DATA[refuelingService];

  const [animatingItemIndexesSet, setAnimatingItemIndexesSet] = useState<
    Set<number>
  >(new Set());

  useEffect(() => {
    const items = document.getElementsByClassName(ITEM_CLASS_NAME);
    const observers = [];

    /**
     * To check if the item is intersecting with the viewport, if it is, add the index to the set.
     */
    Array.from(items).forEach((item, index) => {
      // setAnimatingItemIndexesSet((prev) => prev.add(index));

      const observer = new IntersectionObserver((entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setAnimatingItemIndexesSet((prev) => {
            const newSet = new Set(prev);
            newSet.add(index);
            return newSet;
          });

          return;
        }
        setAnimatingItemIndexesSet((prev) => {
          const newSet = new Set(prev);
          newSet.delete(index);
          return newSet;
        });
      });

      observer.observe(item);
      observers.push(observer);
    });
  }, []);

  return (
    <ul className={cx('list')}>
      {list.map(({ id, lottie, content }, index) => {
        const isPlay = animatingItemIndexesSet.has(index);

        return (
          <li className={`${cx('item-container')} ${ITEM_CLASS_NAME}`} key={id}>
            <span className={cx('item-content')}>{content}</span>
            <Lottie
              style={{ cursor: 'default' }}
              height="180px"
              isStopped={!isPlay}
              options={{
                animationData: lottie,
                loop: false,
                autoplay: isPlay,
              }}
            />
          </li>
        );
      })}
    </ul>
  );
};
